import { UserDto } from '../models/user.dto'
import { User } from '../models/user'

export const userMapper = {
  mapToSignedInUser(userDto: UserDto): User {
    return User.asSignedIn({
      username: userDto.username,
      email: userDto.email,
      firstName: userDto.firstName,
      lastName: userDto.lastName,
    })
  },
}
